import { useState, useEffect } from 'react';

/**
 * Responds to CSS media query changes.
 *
 * @param {string} query - CSS media query string
 * @returns {boolean} Whether the media query currently matches
 *
 * @example
 * const isMobile = useMediaQuery('(max-width: 768px)');
 * const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
 */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    });

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const handler = (event) => setMatches(event.matches);

        mediaQuery.addEventListener('change', handler);
        // Sync initial value
        setMatches(mediaQuery.matches);

        return () => mediaQuery.removeEventListener('change', handler);
    }, [query]);

    return matches;
}
